import { render } from "./App.vue?vue&type=template&id=65a52917"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=65a52917&lang=css"

import exportComponent from "E:\\Awamer work\\my projects\\Nuxt\\A new work\\saqf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__